
import Discover from "../../../assets/outline/Discover.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DiscoverIcon({ className, dataTestid = "DiscoverIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Discover data-testid={dataTestid} className={classes} {...rest} />
  );
}
